import { createFileRoute } from '@tanstack/react-router';
import { useEffect, useRef, useState } from 'react';
import { z } from 'zod';
import { ActivateAccount } from '../components/auth/ActivateAccount';
import { AuthLayout } from '../components/layouts/AuthLayout';

const schema = z.object({
    email: z.string().email(),
    tempPassword: z.string().min(1),
});

export const Route = createFileRoute('/activate')({
    validateSearch: (s: Record<string, unknown>) => schema.parse(s),
    component: ActivateRoute,
});

function ActivateRoute() {
    const { email, tempPassword } = Route.useSearch();
    const capturedRef = useRef<{ email: string; tempPassword: string } | null>(null);
    const [captured, setCaptured] = useState<{ email: string; tempPassword: string } | null>(null);

    useEffect(() => {
        if (capturedRef.current) return;
        capturedRef.current = { email, tempPassword };
        setCaptured({ email, tempPassword });
        window.history.replaceState({}, '', '/activate');
    }, [email, tempPassword]);

    if (!captured) return null;
    return (
        <AuthLayout>
            <ActivateAccount email={captured.email} tempPassword={captured.tempPassword} />
        </AuthLayout>
    );
}
